// extracted by mini-css-extract-plugin
module.exports = {"grid":"ThreeThirds_grid__mFVdO"};